var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Collapse as CollapseIcon } from '@class-ui/icons/dist/Collapse';
import Fab from '@mui/material/Fab';
import { styled } from '@mui/material/styles';
import Tooltip from '@mui/material/Tooltip';
// The transition is the same as MUI's Drawer
const StyledButton = styled(Fab) `
    border-radius: 100px;
    position: fixed;
    left: ${(props) => (props.open ? '382px' : '20px')};
    bottom: 20px;
    z-index: ${(props) => props.theme.zIndex.drawer + 10};
    transition: ${({ theme }) => theme.transitions.create('all', {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.enteringScreen
})};
`;
const ExpandIcon = styled(CollapseIcon) `
    transform: rotate(180deg);
`;
export const SidebarHandle = (props) => {
    const { open, texts } = props, buttonProps = __rest(props, ["open", "texts"]);
    const label = open ? texts.close : texts.open;
    return (_jsx(Tooltip, { title: label, children: _jsx(StyledButton, Object.assign({ open: open, size: 'small', "aria-label": label }, buttonProps, { children: open ? _jsx(CollapseIcon, { sx: { ':-moz-any()': 'x' } }) : _jsx(ExpandIcon, { sx: { ':-moz-any()': 'x' } }) })) }));
};
